let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cehAI")).then(() => parcelRequire('4xObW'));